import { Box, IconButton, PopperPlacementType } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Popper from "../components/popper/Popper";
import { ReactNode, useState } from "react";

interface HelpItemProps {
  helpText: string | ReactNode;
  fieldLabelId: string;
}

export default function HelpItem({ helpText, fieldLabelId }: HelpItemProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [placement, setPlacement] = useState<PopperPlacementType>();

    const handleClick =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setIsOpen((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

    if (!helpText) {
        return null;
    }

    return (
        <Box sx={{ verticalAlign: 'text-bottom', display: 'inline-block' }}>
            <Popper isOpen={isOpen} anchorEl={anchorEl} placement={placement} onClose={() => setIsOpen(false)}>
                {helpText}
            </Popper>
            <IconButton
                onClick={handleClick('right-end')}
                aria-label={fieldLabelId}
                data-testid={`help-label-${fieldLabelId}`}
                sx={{ p: 0, marginLeft: '5px' }}
            >
                <InfoOutlinedIcon sx={{ color: '#6C6F80', fontSize: '14px' }} />
            </IconButton>
        </Box>
    );
}